var React = require('react');

function Zoom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.61 0a8.61 8.61 0 016.624 14.11l6.155 6.155-1.74 1.739-6.243-6.244A8.61 8.61 0 118.61 0zm0 2.46a6.157 6.157 0 00-6.15 6.15 6.157 6.157 0 006.15 6.15 6.157 6.157 0 006.15-6.15 6.157 6.157 0 00-6.15-6.15zm1.23 2.46v2.46h2.46v2.46H9.84v2.46H7.38V9.84H4.92V7.38h2.46V4.92h2.46z","fillRule":"evenodd"}));
}

Zoom.defaultProps = {"width":"22","height":"22"};

module.exports = Zoom;

Zoom.default = Zoom;
